import { DawnTick } from '@xemplo/icons';

import { CheckboxSize } from './checkbox.types';

export const checkmarkSizeMap = {
  [CheckboxSize.Large]: <DawnTick fontSize="1.5em" />,
  [CheckboxSize.Medium]: <DawnTick fontSize="26" />,
  [CheckboxSize.Small]: <DawnTick fontSize="24" />,
};

export const heightAndWidthMap = {
  [CheckboxSize.Large]: '24px',
  [CheckboxSize.Medium]: '20px',
  [CheckboxSize.Small]: '16px',
};
export const boxShadowMap = {
  [CheckboxSize.Large]: '12px',
  [CheckboxSize.Medium]: '10px',
  [CheckboxSize.Small]: '8px',
};
